import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import masterApi from "../api/masterApi";
import { PERFORMANCE_QUERY_KEYS } from "../constants/performanceConstants";

const useReviewTemplateOptions = () => {
  const templatesQuery = useQuery({
    queryKey: [PERFORMANCE_QUERY_KEYS.reviewTemplates, "selector"],
    queryFn: () => masterApi.listReviewTemplates({ page: 1, limit: 100 }),
  });

  const templates = useMemo(() => {
    const rows = templatesQuery.data?.data;
    return Array.isArray(rows) ? rows : [];
  }, [templatesQuery.data]);

  const reviewTemplateOptions = useMemo(
    () =>
      templates.map((template) => ({
        value: template._id,
        label: [
          template.code ? `${template.name} (${template.code})` : template.name,
          template.status,
        ]
          .filter(Boolean)
          .join(" - "),
      })),
    [templates],
  );

  return {
    reviewTemplateOptions,
    isLoading: templatesQuery.isLoading,
  };
};

export default useReviewTemplateOptions;
